import Api from '@/lib/api/v1/api'
import settings from '@/lib/core/settings'

const api = new Api(settings)
export default api
